module.exports = __webpack_public_path__ + "img/user.df413e8d.png";